import config from "./config";
var axios = config();

export default {
  getBuyouts() {
    return axios.get("/api/BuyoutRequests");
  },
  getByAsurite(asurite) {
    return axios.get("/api/BuyoutRequests/employee/" + asurite);
  },
  getByWorkload(workloadId) {
    return axios.get("/api/BuyoutRequests/workload/" + workloadId);
  },
  getById(id) {
    return axios.get("/api/BuyoutRequests/" + id);
  },
  postBuyout(buyout) {
    return axios.post("/api/BuyoutRequests", buyout);
  },
  putBuyout(buyout) {
    return axios.put("/api/BuyoutRequests", buyout);
  },
  postStatus(buyout) {
    return axios.post("/api/BuyoutRequests/status", buyout);
  },

  //emails
  statusEmail(id) {
    return axios.post("/api/BuyoutRequests/statusEmail/" + id);
  },

  submittedEmail(id) {
    return axios.post("/api/BuyoutRequests/submittedEmail/" + id);
  },
  // utils
  getStatusDefinitions() {
    return axios.get("/api/BuyoutRequests/statuses");
  }
};
